export const notificationTypes = {
  PARTICIPATION_ASSIGNEE_ASSIGNED: 'participation-assignee_assigned',
  PARTICIPATION_ASSIGNEEE_UNASSIGNED: 'participation-assignee_unassigned',
  PARTICIPATION_OWNER_CHANGED: 'participation-owner_changed',
  VEHICLE_NEXT_SERVICE_NOTICE: 'vehicle-next_service_notice',
  VEHICLE_INSPECTION_EXPIRATION_NOTICE: 'vehicle-inspection_expiration_notice',
  VEHICLE_FILE_OPREATION_FINISHED: 'vehicle-file_operation_finished',
  VEHICLE_BACKGROUND_REMOVAL_FINISHED: 'vehicle_photo-remove_background_finished',
  SALE_VEHICLE_BACKGROUND_REMOVAL_FINISHED: 'sale_vehicle_photo-remove_background_finished',
  VEHICLE_PHOTO_ROTATE_FINISHED: 'vehicle_photo-rotate_finished',
  VEHICLE_PHOTO_COPY_FINISHED: 'vehicle_photo-copy_finished',
  SALE_VEHICLE_PHOTO_ROTATE_FINISHED: 'sale_vehicle_photo-rotate_finished',
  SALE_VEHICLE_PHOTO_COPY_FINISHED: 'sale_vehicle_photo-copy_finished',
  BATCH_DOWNLOAD_STATE_CHANGED: 'batch_download-bulk_event_state_changed',
  COMMENT_MENTION: 'comment-mention',
  COMMENT_RECORD_OWNER: 'comment-record_owner',
  SALE_VEHICLE_RESERVATION_CANCELLED: 'sale_vehicle-reservation_cancelled',
  PERMISSION_CHANGED: 'access_control-user_permission_changed',
  DATAGRID_CUSTOM_PRESET_SHARED: 'datagrid-custom_preset_shared',
  FILE_STORAGE_FILE_UPLOADED: 'file_storage-file_uploaded',
  FILE_STORAGE_FILE_VARIANT_UPLOADED: 'file_storage-file_variant_uploaded',
  VEHICLE_WARRANTY_EXPIRATION_NOTICE: 'vehicle-warranty_expiration_notice',
  VEHICLE_DAYS_SINCE_LAST_REPRICE_NOTICE: 'vehicle-days_since_last_reprice_notice',
  VEHICLE_UNREGISTERED_NOTICE: 'vehicle-unregistered_notice',
  ADVERTISEMENT_PUBLISHING_FAILED: 'advertisement-publishing_failed',
  SOURCING_FILTER_PRESET_UPDATE: 'sourcing-filter_preset_update',
  DATAGRID_EXPORT: 'datagrid-data_export',
  DIGITAL_DOCUMENT_SIGNED: 'digital_signature-document_signed',
  TASK_CREATED: 'task_management-task_created',
  TASK_UPDATED: 'task_management-task_updated',
  TASK_DUE_DATE_NOTICE: 'task_management-due_date_notice',
  TASK_COMMENTED: 'task_management-task_commented',
  TASK_REPORTER_CHANGED: 'task_management-task_reporter_changed',
  CUSTOM_FIELDS_NOTICE: 'custom_fields-expiration_notice',
  VEHICLE_INSPECTION_CLONED: 'vehicle-inspection_cloned',
  IMPORT_FINISHED: 'import-finished',
  BUSINESS_CASE_QUICK_UNREAD_MESSAGE: 'business_case-quick_unread_message',
  BUSINESS_CASE_UNREAD_MESSAGE: 'business_case-unread_message',
  VEHICLE_INSPECTION_TO_REVISION: 'vehicle-inspection_to_review',
  VEHICLE_INSPECTION_RETURNED_TO_COMPLETION: 'vehicle-inspection_returned_for_completion',
  VEHICLE_INSPECTION_FINISHED: 'vehicle-inspection_finished',
  INTEGRATED_SERVICE_CHANGE: 'integrated_service-change_announced',
  INTEGRATED_SERVICE_EXTERNAL_PLANNER_CONFLICT: 'integrated_service-external_planner_conflict',
  PROMPT_BRIDGE_STATUS_CHANGED: 'prompt_bridge-status_changed',
  OFFER_VALIDITY_EXPIRATION: 'offer-validity_expiration',
  MAGIC_PUBLISHING_FINISHED: 'magic_publishing-finished',
} as const;
